import React from 'react';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';
import { Col, Form, Row } from 'react-bootstrap';
import FormRow from '../../../../../common/components/FormRow/FormRow';
import { getFormValues, reduxForm } from 'redux-form';
import { InfoButton, InfoLabel } from '../../../../../common/components';
import { compose } from 'redux';
import { connect } from 'react-redux';

const RenewsToForm = ({ handleSubmit, isViewOnly, renewsTo }) => {
  return (
    <SchemeManagementSectionContainer
      title={''}
      subTitle={'Renews To'}
      isViewOnly={isViewOnly}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className="section-item">
          <Col sm={12}>
            <FormRow
              labelSize={2}
              fieldSize={4}
              label={
                <>
                  <InfoButton
                    content={
                      'This is the schemes that policies issued on this scheme will renew to if this scheme is ended.  '
                    }
                  />
                  Scheme
                </>
              }
            >
              <InfoLabel value={renewsTo?.data?.attributes?.name ?? 'Not set'} />
            </FormRow>
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(RenewsToForm);
